function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var BankOfAmericaInverted = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.94 30.8425C26.2558 25.4283 35.1275 20.1658 40 18.2708C39.2483 17.7892 38.075 17.0975 36.7516 16.3458C30.4658 18.4208 23.1275 23.0225 16.5708 28.2258C17.6841 29.0675 18.8566 29.94 19.94 30.8425Z",
    fill: "white"
  }), /*#__PURE__*/_jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0525 16.1358C16.12 15.6842 15.0975 15.2633 14.3158 14.9025C11.94 16.075 8.84166 17.85 4.9325 20.6467C5.775 21.0983 6.67666 21.6392 7.63916 22.1808C10.6467 19.955 13.6842 17.85 17.0525 16.1358Z",
    fill: "white"
  }), /*#__PURE__*/_jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.2325 13.1583C5.71417 14.7825 2.015 17.0075 0 18.3008C0.721667 18.6317 1.44333 18.9025 2.43583 19.3833C6.88667 16.3758 10.3758 14.5408 11.7592 13.94C10.7667 13.5783 9.83417 13.3383 9.2325 13.1583Z",
    fill: "white"
  }), /*#__PURE__*/_jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6766 13.5492C21.5333 12.9175 17.5641 11.4433 14.8266 10.8125C14.015 11.1133 12.8716 11.5642 12.09 11.895C13.0825 12.1658 16.7816 13.1583 19.94 14.7525C20.7516 14.3608 21.895 13.88 22.6766 13.5492Z",
    fill: "white"
  }), /*#__PURE__*/_jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3233 12.6167C26.135 12.3458 27.0683 12.105 27.88 11.8642C25.5342 10.8717 22.5867 9.81917 19.94 9.1575C19.5192 9.2775 18.2558 9.60917 17.3833 9.87917C18.2858 10.1508 21.2625 10.8425 25.3233 12.6167ZM10.4958 23.925C11.4583 24.4967 12.4808 25.2783 13.4733 25.94C20.06 20.8275 26.5558 16.8875 33.6842 14.6617C32.6917 14.1508 31.8192 13.7 30.7067 13.1583C26.4358 14.2408 19.1275 17.1575 10.4958 23.925Z",
    fill: "white"
  })]
}));
BankOfAmericaInverted.displayName = 'BankOfAmericaInverted';
//# sourceMappingURL=BankOfAmericaInverted.js.map